<template>
	<div class="modal-body">
		<div class="row">
			<div class="col-sm-12">
				<span>Usuário</span>
				<input type="text" v-model="data.user" class="form-control" />
			</div>
			<div class="col-sm-12">
				<span>Perfil</span>
				<select v-model="data.perfil" class="form-control">
					<option
						v-for="(perfil, index) in assets.perfis"
						:key="index"
						:value="perfil.cod"
					>
						{{ perfil.desc }}
					</option>
				</select>
			</div>

			<div class="col-sm-6" :class="{ 'has-error': passDiff }">
				<span>Senha</span>
				<input type="password" v-model="senha" class="form-control" />
			</div>
			<div class="col-sm-6" :class="{ 'has-error': passDiff }">
				<span>Repita a senha</span>
				<input type="password" v-model="rsenha" class="form-control" />
			</div>
		</div>
	</div>
</template>
<script>
	import md5 from 'js/md5';
	export default {
		name: 'UserMdaccessInfo',
		inject: ['assets'],
		props: ['dataIn', 'page'],
		data() {
			return {
				senha: '',
				rsenha: '',
				passDiff: false,
			};
		},
		computed: {
			data() {
				return this.dataIn;
			},
		},
		watch: {
			'data.cod': function () {
				(this.senha = ''), (this.rsenha = ''), (this.data.pass = '');
			},
			senha: function (val) {
				this.data.pass = 'altpass';
				if (this.rsenha == val) {
					this.data.pass = md5.get(val);
				}
			},
			rsenha: function (val) {
				this.data.pass = 'altpass';
				if (this.senha == val) {
					this.data.pass = md5.get(val);
				}
			},
		},
		mounted() {
			this.senha = '';
			this.rsenha = '';
			this.data.pass = '';
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/settings/users/modal/accessInfo.vue